import { Dispatch } from 'react';
import { createNamedContext } from '@utils';
import { Site, Strategy } from './interfaces';

type StrategyDispatch = Dispatch<Strategy>;

export const SiteStrategyStateContext = createNamedContext<Strategy | undefined>(undefined, 'SiteStrategyStateContext');
export const SiteStrategyDispatchContext = createNamedContext<StrategyDispatch | undefined>(undefined, 'SiteStrategyDispatchContext');

export const SiteElementContext = createNamedContext<Site.Content>(undefined, 'SiteElementContext');